<mat-dialog-content style="min-height: 80px;">
  @if (declarationInteret === null) {
    <div>
      <p>Pas de déclaration d'intérêt publique</p>
    </div>
  }
  @if (declarationInteret !== null) {
    <div>
      <div class="row">
        <div class="col-md-12">
          <h4>Liens concernant une activité en lien avec l'employeur principal</h4>
          <table class="table-simple">
            <tr class="enteteTableau1">
              <th width="20%">Date / 5 ans</th>
              <th width="30%">Employeur principal</th>
              <th width="30%">Adresse de l'employeur</th>
              <th width="20%">Fonction occupée</th>
            </tr>
            @for (autresActivites of declarationInteret['tab1lines']; track autresActivites) {
              <tr class="lines-simple">
                <td>{{autresActivites.dateLine}}</td>
                <td>{{autresActivites.employeur}}</td>
                <td>{{autresActivites.lieu}}</td>
                <td>{{autresActivites.fonction}}</td>
              </tr>
            }
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4>{{ 'general.liensConcernantAutresActivites' | translate }}</h4>
          <table class="table-simple">
            <tr>
              <th width="20%">Date / 5 ans</th>
              <th width="30%">Mission, <br>rôle responsablité</th>
              <th width="30%">Lieu d'exercice</th>
              <th width="20%">Rémunération</th>
            </tr>
            @for (autresActivites of declarationInteret['tab2lines']; track autresActivites) {
              <tr class="lines-simple">
                <td>{{autresActivites.dateLine}}</td>
                <td>{{autresActivites.fonction}}</td>
                <td>{{autresActivites.lieu}}</td>
                <td>{{autresActivites.remuneration}}</td>
              </tr>
            }
          </table>
        </div>
      </div>
      <h4>Autres liens d'interets : </h4>
      @if (declarationInteret['autreLienInteret'] === null) {
        <div>
          <p>Pas d'autre lien d'intérêt à porter à connaissance </p>
        </div>
      }
      @if (declarationInteret['autreLienInteret'] !== null) {
        <div class="w-100">
          {{declarationInteret['autreLienInteret']}}
        </div>
      }
    </div>
  }
</mat-dialog-content>
